import { createContext } from 'react';
import { PredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/predefined-comments.model';

export interface PredefinedCommentsListContextProps {
    comments: PredefinedComment[];
    isTableLoading: boolean;
    showOnlyActive: boolean;
    selectedRows: PredefinedComment[];
    setSelectedRows: React.Dispatch<React.SetStateAction<PredefinedComment[]>>;
    refreshList: VoidFunction;
    handleOnSelectRow: (id: string, isSelected: boolean) => void;
    handleShowOnlyActiveChange: (value: boolean) => void;
    setShowOnlyActive: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PredefinedCommentsListContext = createContext<PredefinedCommentsListContextProps | undefined>(undefined);
